import React, { useEffect, useContext, useRef, useCallback } from "react";
import DatabaseContext from "data/contextDatabase";
import GlobalContext from "contexts/context";
import WebRTCContext from "connectivity/contextWebRTC";
import { useLiveStreamMessages } from "hooks/dbHooks";
import { randomString } from "hooks/helper";

const WebRTC = (props) => {
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const { globalState } = useContext(GlobalContext);
  const liveStreamMessages = useLiveStreamMessages(databaseState.dbMaster, 1);
  const { webRTCState, webRTCDispatch } = useContext(WebRTCContext);

  const invite = () => {
    webRTCDispatch({
      type: "invite",
      values: {
        mpersona: props.mpersona,
        peermpersona: props.peermpersona,
        db: databaseState.dbMaster,
        databaseDispatch: databaseDispatch,
        version: globalState.version,
      },
    });
  };

  const hangUpCall = () => {
    console.log("hangup answer");
    webRTCDispatch({
      type: "w.mpersona.stream.hang_up.self",
      values: {},
    });
    databaseDispatch({
      type: "DELETE_STREAM_MESSAGES",
      values: {
        db: databaseState.dbMaster,
      },
    });
    let j = {
      version: globalState.version,
      type: "w.mpersona.stream.hang_up",
      mpersona: props.mpersona,
      peer: props.peermpersona,
      smid: randomString(8),
      ts_sender: "",
    };
    databaseState.dbMaster &&
      databaseDispatch({
        type: "UPSERT_REC",
        values: {
          jmessage: j,
          db: databaseState.dbMaster,
          collection: "send",
          table: "confirm_smid",
          rowid: j.smid,
          doc: j,
        },
      });
  };

  useEffect(() => {
    let liveStreamMessage = liveStreamMessages.slice(-1)[0];
    console.log("!liveStreamMessages ", liveStreamMessages);
    console.log("!liveStreamMessage ", liveStreamMessage);
    let type = liveStreamMessage?.type;
    switch (type) {
      case "w.mpersona.stream.offer":
        (!webRTCState.session &&
          props.mpersona === liveStreamMessage.mpersona) ||
          webRTCDispatch({
            type: "w.mpersona.stream.offer",
            values: {
              message: liveStreamMessage,
              mpersona: props.mpersona,
              peermpersona: props.peermpersona,
              db: databaseState.dbMaster,
              databaseDispatch: databaseDispatch,
              version: globalState.version,
            },
          });
        break;
      case "w.mpersona.stream.new_ice_candidate":
        props.mpersona === liveStreamMessage.mpersona ||
          webRTCDispatch({
            type: "w.mpersona.stream.new_ice_candidate",
            values: {
              message: liveStreamMessage,
            },
          });
        break;
      case "w.mpersona.stream.hang_up":
        props.mpersona === liveStreamMessage.mpersona ||
          webRTCDispatch({
            type: "w.mpersona.stream.hang_up",
            values: {
              message: liveStreamMessage,
            },
          });
        props.mpersona === liveStreamMessage.mpersona ||
          databaseDispatch({
            type: "DELETE_STREAM_MESSAGES",
            values: {
              db: databaseState.dbMaster,
            },
          });
        break;
      case "w.mpersona.stream.answer":
        props.mpersona === liveStreamMessage.mpersona ||
          webRTCDispatch({
            type: "w.mpersona.stream.answer",
            values: {
              message: liveStreamMessage,
            },
          });
        break;
      default:
        break;
    }
    // Delete the message
    let m = {
      type: "DELETE_RECORD_ID",
      values: {
        db: databaseState.dbMaster,
        doc: liveStreamMessage,
      },
    };
    liveStreamMessage && databaseState.dbMaster && databaseDispatch(m);
    return () => {};
  }, [
    databaseDispatch,
    databaseState.dbMaster,
    globalState.version,
    liveStreamMessages,
    props.mpersona,
    props.peermpersona,
    webRTCDispatch,
    webRTCState.session,
  ]);

  const content = (
    <div>
      <button id="invite-button" onClick={() => invite()}>
        Start call
      </button>
      <button id="hangup-button" onClick={() => hangUpCall()}>
        Hang Up
      </button>
    </div>
  );

  return content;
};

export default React.memo(WebRTC, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
